import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { addDefaultOption, formatCsvStudentNames, formatStudentNames } from "../../../../../utils/utility";
import { AutoGrowTextarea } from "../../../../../components/AutoGrowTextarea";
import VerifiedStudentsTable from "../../Quotation/Forms/VerifiedStudentsTable";

const OtherItem = ({
    control,
    index,
    configValues,
    handleCourseChange,
    errors,
    setValue,
    getValues,
}) => {
    const [studentArrays, setStudentArrays] = useState([]);
    const [selectedOption, setSelectedOption] = useState("studentNames");

    const handleOptionChange = (option) => {
        // Clear student information when switching options
        setStudentArrays((prevStudentArrays) => {
            const newStudentArrays = [...prevStudentArrays];
            newStudentArrays[index] = [];
            return newStudentArrays;
        });

        // Update selected option
        setSelectedOption(option);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onload = (event) => {
                const fileContent = event.target.result;

                // Parse the file content manually or using a different library
                // Here is a simple example assuming the file is in CSV format
                const rows = fileContent.split('\n');

                const studentsFromExcel = formatCsvStudentNames(rows);

                // Update the studentArrays in the component state
                setStudentArrays((prevStudentArrays) => {
                    const newStudentArrays = [...prevStudentArrays];
                    newStudentArrays[index] = studentsFromExcel;
                    return newStudentArrays;
                });

                // Update the form's value for items[${index}].student
                setValue(`items[${index}].students`, studentsFromExcel);
                // Do whatever you need to do with the array of objects here
            };

            reader.readAsText(file);
        }
    };

    const verifyStudents = (index) => {
        // Get the value from the student_names input box
        const studentNames = getValues(`items[${index}].student_names`);
        if (!studentNames || studentNames.trim() === '') {
            return;
        }
        // Split the string by lines and create an array of objects
        const students = formatStudentNames(studentNames);



        // Update the studentArrays in the component state
        setStudentArrays((prevStudentArrays) => {
            const newStudentArrays = [...prevStudentArrays];
            newStudentArrays[index] = students;
            return newStudentArrays;
        });
        // console.log("This are student names: ", studentNames);
    };

    const handleStudentNameChange = (index, studentIndex, event) => {
        const newName = event.target.value;
        setStudentArrays((prevStudentArrays) => {
            const newStudentArrays = [...prevStudentArrays];
            newStudentArrays[index][studentIndex].name = newName;
            return newStudentArrays;
        });

    };

    const handleStudentIdNumberChange = (index, studentIndex, event) => {
        const newIdNumber = event.target.value;
        setStudentArrays((prevStudentArrays) => {
            const newStudentArrays = [...prevStudentArrays];
            newStudentArrays[index][studentIndex].id_number = newIdNumber;
            return newStudentArrays;
        });

    };

    const removeStudent = (index, studentIndex) => {
        const shouldRemove = window.confirm("Are you sure you want to remove this student?");

        if (shouldRemove) {
            setStudentArrays((prevStudentArrays) => {
                const newStudentArrays = [...prevStudentArrays];
                newStudentArrays[index].splice(studentIndex, 1);
                return newStudentArrays;
            });

        }
    };

    useEffect(() => {
        // This effect will run whenever studentArrays changes
        setValue(`items[${index}].students`, studentArrays[index]);
        // console.log("This is student array: ", studentArrays);
    }, [studentArrays, setValue, index]);

    return (
        <table width="100%">
            <tbody>
                <tr>
                    <td colSpan={2}>
                        <div className="">
                            <label
                                htmlFor={`items[${index}].course_code`}
                                className="form-label"
                            >
                                Item code
                            </label>
                            <div className=" quotation_min_height">
                                    <Controller
                                        name={`items[${index}].other_item`}
                                        control={control}
                                        defaultValue={
                                            configValues.other_item
                                            || "Add unregistered item here"
                                        }
                                        render={({ field }) => (
                                            <AutoGrowTextarea
                                                name={field.name}
                                                id={field.id}
                                                fieldValue={field.value}
                                                handleBlur={field.onBlur}
                                                isInvalid={!!errors.address}
                                                handleFormChangeDetails={
                                                    field.onChange
                                                }
                                            />
                                        )}
                                    />
                                {errors &&
                                    errors.items &&
                                    errors.items[index] &&
                                    errors.items[index].course_code && (
                                        <div className="text-danger mt-2 text-sm">
                                            Item code is required
                                        </div>
                                    )}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colSpan={1}>
                        <div className="mb-3">
                            <label className="form-label">Choose input method:</label>
                            <div>
                                <label className="mx-2">
                                    <input
                                        type="radio"
                                        name={`inputMethod_${index}`}
                                        value="studentNames"
                                        checked={selectedOption === "studentNames"}
                                        onChange={() => handleOptionChange("studentNames")}
                                    />
                                    {""} Student names
                                </label>
                                <label className="mx-2 ">
                                    <input
                                        type="radio"
                                        name={`inputMethod_${index}`}
                                        value="excel"
                                        checked={selectedOption === "excel"}
                                        onChange={() => handleOptionChange("excel")}
                                    />
                                    {""} Excel(CSV)
                                </label>
                            </div>
                        </div>

                        {selectedOption === 'studentNames' && <div className="mb-3">
                            <label
                                htmlFor={`items[${index}].student_names`}
                                className="form-label"
                            >
                                Student name (separated by comma)
                            </label>
                            <Controller
                                name={`items[${index}].student_names`}
                                control={control}
                                render={({ field }) => (
                                    <>
                                        <AutoGrowTextarea
                                            name={`items[${index}].student_names`}
                                            id={field.id}
                                            fieldValue={field.value}
                                            handleBlur={field.onBlur}
                                            isInvalid={!!errors.student_names}
                                            handleFormChangeDetails={
                                                field.onChange
                                            }
                                            // style={{ minWidth: '5000px' }}
                                        />
                                    </>
                                )}
                            />
                            <br/>
                            <button className="btn btn-sm btn-info" onClick={(e) => {
                                e.preventDefault(); // Prevent the default form submission
                                verifyStudents(index);
                            }}>Verify</button>
                        </div>
                        }
                        {selectedOption === 'excel' && <div className="mb-3">
                            <label htmlFor={`fileInput_${index}`} className="form-label">
                                Choose Excel File
                            </label>
                            <br/>
                            <input
                                type="file"
                                id={`fileInput_${index}`}
                                onChange={handleFileChange}
                                accept=".xlsx, .xls, .csv"
                                style={{ width: "300px" }}
                            />

                        </div>
                        }
                        {errors &&
                            errors.items &&
                            errors.items[index] &&
                            errors.items[index].student_names && (
                                <div className="text-danger text-sm">
                                    Students is required
                                </div>
                            )}
                    </td>
                    <td colSpan={1} valign="top">
                        <div className="px-2">
                            <strong>Verified students:</strong>
                            <VerifiedStudentsTable
                                studentArray={studentArrays[index] || []}
                                onNameChange={(studentIndex, e) => handleStudentNameChange(index, studentIndex, e)}
                                onIdNumberChange={(studentIndex, e) => handleStudentIdNumberChange(index, studentIndex, e)}
                                onRemove={(studentIndex) => removeStudent(index, studentIndex)}
                                showRemove ={true}
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default OtherItem;
